import { Button, Callout } from '@dev-spendesk/grapes';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

type Props = {
  className?: string;
};

export const ApprovalByDimensionsMarketingBanner = ({ className }: Props) => {
  const { t } = useTranslation('global');
  const history = useHistory();
  const companyId = useCompanyId();

  return (
    <Callout
      variant="info"
      title={t('costCenters.dimensionsBanner.title')}
      className={classNames('text-left', className)}
    >
      <div className="mb-8">
        {t('costCenters.dimensionsBanner.description')}
      </div>
      <Button
        variant="primaryInfo"
        onClick={() => {
          history.push(
            routeFor(routes.APPROVAL_WORKFLOWS.path, {
              company: companyId,
            }),
          );
        }}
        text={t('costCenters.dimensionsBanner.actionText')}
      />
    </Callout>
  );
};
